<span
  class="karma-unavailable-badge"
  *ngIf="unavailable"
  role="button"
  tabindex="0"
  [title]="tooltip"
  (click)="onClick($event)"
>
  Nicht verfügbar
</span>
